import { buildSTARResponse } from '../starBuilder.js';

function update() {
    const input = {
        role: document.getElementById('role').value,
        company: document.getElementById('company').value,
        situation: document.getElementById('situation').value,
        task: document.getElementById('task').value,
        action: document.getElementById('action').value,
        result: document.getElementById('result').value
    };

    const result = buildSTARResponse(input);
    const preview = document.getElementById('preview');
    const stats = document.getElementById('stats');

    if (!result) {
        preview.innerHTML = '<p style="color:#6b7280;">Fill in the fields above to see your formatted answer.</p>';
        stats.innerHTML = '';
        return;
    }

    // Completeness indicator
    const completeness = result.isComplete
        ? '<span style="color:#059669;font-weight:700;">✓ All STAR sections complete</span>'
        : `<span style="color:#d97706;font-weight:700;">Missing: ${result.missing.join(', ')}</span>`;

    const lengthFeedback = result.wordCount < 100
        ? '<span style="color:#d97706;">Too short — aim for 100+ words</span>'
        : result.wordCount > 250
        ? '<span style="color:#d97706;">Consider trimming — ideal is 100–250 words</span>'
        : '<span style="color:#059669;">✓ Great length for an interview answer</span>';

    stats.innerHTML = `
        <div style="display:flex;gap:1.5rem;flex-wrap:wrap;margin-bottom:1rem;">
            <div><strong>${result.wordCount}</strong> words</div>
            <div><strong>~${result.speakingTime} min</strong> speaking time</div>
            <div>${completeness}</div>
            <div>${lengthFeedback}</div>
        </div>
    `;

    preview.innerHTML = result.sections.map(s =>
        `<div class="star-section">
            <span class="star-label">${s.label}</span>
            <p>${s.text}</p>
        </div>`
    ).join('');

    document.getElementById('fullResponse').value = result.formatted;
}

function copyResponse() {
    const textarea = document.getElementById('fullResponse');
    textarea.select();
    document.execCommand('copy');
    const btn = document.getElementById('copyBtn');
    btn.textContent = '✓ Copied!';
    setTimeout(() => btn.textContent = 'Copy Full Response', 2000);
}

['role', 'company', 'situation', 'task', 'action', 'result'].forEach(id => {
    document.getElementById(id).addEventListener('input', update);
});

document.getElementById('copyBtn').addEventListener('click', copyResponse);

update();
